import { render } from "./AuthLogout.vue?vue&type=template&id=b5a4eeb2&scoped=true"
import script from "./AuthLogout.vue?vue&type=script&lang=js"
export * from "./AuthLogout.vue?vue&type=script&lang=js"

import "./AuthLogout.vue?vue&type=style&index=0&id=b5a4eeb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a4eeb2"]])

export default __exports__